import { ensureSafeComponent } from "@embroider/util";

const iconsImport = import.meta.glob("../components/icons/**/*.{js,ts,gjs,gts}", { eager: true });

const icons = Object.keys(iconsImport).reduce((acc, key) => {
  acc[key.replace(/\.\w+$/, "")] = iconsImport[key];
  return acc;
}, {});

export default function (icon) {
  let module = icons[`../components/icons/${icon}`];
  if (!module) {
    throw new Error(`Icon component not found: ${icon}`);
  }

  return ensureSafeComponent(module.default, this);
}
